import React from 'react';
import { Alert as AlertStandard } from '@emorg-prd/standard-react';
import './Alert.css';

export enum AlertType {
	Success = 'em-c-alert--success',
	Warning = 'em-c-alert--warning',
	Error = 'em-c-alert--error',
	Default = 'em-c-alert--a11y',
}

export type AlertVariantType = 'default' | 'success' | 'warning' | 'error';

const typeMap: Record<AlertVariantType, AlertType> = {
	default: AlertType.Default,
	success: AlertType.Success,
	warning: AlertType.Warning,
	error: AlertType.Error,
};

interface AlertProps extends React.ComponentProps<typeof AlertStandard> {
	variant?: AlertVariantType;
	onClose?: () => void;
	className?: string;
}

const Alert: React.FC<AlertProps> = (props) => {
	const { variant, className, onClose, ...rest } = props;
	const mappedVariant = typeMap[variant];
	// Without a close button, the alert isn't constrained to the library's line-length max-width.
	const optionalClass = [className, !onClose && 'em-c-alert--full-width'].filter(Boolean).join(' ');

	return (
		<AlertStandard {...rest} type={mappedVariant} optionalClass={optionalClass}>
			{onClose && (
				<button aria-label="Close alert message" className="em-c-text-btn " onClick={onClose}>
					Close
				</button>
			)}
		</AlertStandard>
	);
};

export { Alert };
